import { atom } from 'recoil';

export default atom({
    key: 'tokenState',
    default: window.localStorage.getItem('vanessdeco-admin-token')
});